import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useStateRef from 'react-usestateref'
import useInterval from '@use-it/interval'
import {
  connect,
  StringCodec,
} from "nats.ws";
import { setWindowConnectionState } from '../websocket_connection.jsx'



export default function NatsWebsocketConnection({ onMessageCompleted, channels, ...props}) {

  const config = useSelector(state => state.websocket.nats)

  if(!config || !config.enabled) {
    console.warn("Nats disabled")
    return <></>
  }

  const [renderedConnectionState, setConnectionState, connectionState] = useStateRef("connecting")

  const [connectionRetries, setConnectionRetries] = useState(0)

  const connectionOptions = {
    servers: config?.servers,
    debug: true,
    maxReconnectAttempts: -1,
    reconnectTimeWait: 2000,
    //timeout: 15000
  }

  useEffect(() => {
    setConnectionState("connecting")

    const connectAndSubscribe = async () => {
      try {
        const nc = await connect(connectionOptions)
        setConnectionState("connected")
        console.info(`[NATS] connected ${nc.getServer()}`);
        setWindowConnectionState("nats", true);

        channels.map(channelName => {
          // create a simple subscriber and iterate over messages
          // matching the subscription
          const sub = nc.subscribe(channelName);
          console.log("[NATS] Subscribing to ", channelName);
          (async () => {
            for await (const m of sub) {
              const sc = StringCodec();
              try {
                const result = JSON.parse(sc.decode(m.data))
                onMessageCompleted("nats", result.id, result)
              } catch(ex) {
                console.error(ex)
              }
            }
            console.log("[NATS] subscription closed");
          })();
        });

        (async () => {
          for await (const s of nc.status()) {
            console.info("[NATS]", s, s.type);
            switch(s.type) {
            case "disconnect":
              setConnectionState("disconnected");
              setWindowConnectionState("nats", false);
              break;
            case "reconnect":
              setConnectionState("connected");
              setWindowConnectionState("nats", false);
              break;
            case "reconnecting":
              setConnectionRetries(connectionRetries + 1);
              setConnectionState("connecting");
              setWindowConnectionState("nats", false);
              break;
            case "error":
              setConnectionState("failed");
              setWindowConnectionState("nats", false);
              break;
            }
          }
        })();

        nc.closed().then((err) => {
          if (err) {
            console.log('[NATS] Connection error:', err.message);
            handleConnectionError();
            setWindowConnectionState("nats", false);

          } else {
            console.log('[NATS] Connection closed');
          }
        });

        window.nats = nc

      } catch (err) {
        console.log('[NATS] Failed to connect:', err.message);
        handleConnectionError()
      }
    }

    const handleConnectionError = () => {
      setTimeout(() => {
        connectAndSubscribe();
      }, connectionOptions.reconnectTimeWait);
    }
    connectAndSubscribe()

    return () => {
      if (window.nats) {
        console.warn("Unloading nats");
        window.nats.close();
      }
    };
  }, [])




  if(!config) {
    return <div className="label label-danger badge badge-danger">
      Invalid Nats Configuration
    </div>
  }

  if(false) {
    return <div style={{fontSize: "0.6rem", padding: "10px", backgroundColor: "white"}}>
      <pre>{JSON.stringify(parseJwt(config.token), null, 3)}</pre>
      <div className="btn btn-danger btn-sm" onClick={() => { 
          //client.publish({ destination: '/exchange/public', body: encode('Hello world') }); 
          client.publish({ destination: '/queue/public', body: encode('Hello world') }); 

        } }>
        Publish
      </div>
    </div>
  }


  switch(connectionState?.current) {
    case "initialized":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Initializing via NATS... Try #{connectionRetries}
      </div>
    case "connecting":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Connecting via NATS... Try #{connectionRetries}
      </div>
    case "connected":
      return <div className="network-status network-status-success">
        <i className="fa fa-check"></i>{" "}
        NATS connected
      </div>
    case "unavailable":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        No connection to NATS
      </div>

    case "failed":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Connection failed to NATS
      </div>
    case "disconnected":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Network disconnect.
      </div>
    case "unloading":
      return <></>
    default:
      return <div className="network-status network-status-danger">Unknown connection state for  Nats</div>
  }

  return <></>


  // useEffect(() => {

  //   const nc = connect({ servers: "localhost:4222"});
  //   console.log(`connected to ${nc.getServer()}`);
  //   // this promise indicates the client closed
  //   const done = nc.closed();

  //   client.connection.bind("initialized", connectionInitialized)
  //   client.connection.bind("connecting", connectionConnecting)
  //   client.connection.bind("connected", connectionConnected)
  //   client.connection.bind("unavailable", connectionUnavailable)
  //   client.connection.bind("failed", connectionFailed)
  //   client.connection.bind("disconnected", connectionDisconnected)
  //   client.connection.bind("unloading", connectionUnloading)

  //   channels.map(channelName => {

  //     const subscription = client.subscribe(channelName).bind_global((eventName, message) => {
  //       if(eventName.startsWith("CABLE_")) {
  //         console.warn(eventName)
  //         console.warn(message)
  //         if (message.data) {
  //           //const rawData = decode(message.binaryBody)
  //           console.debug('got message in channel ' + channelName + ' with body ', message.data);
  //           //const data = JSON.parse(message.data)
  //           try {
  //             onMessageCompleted("pusher", message.id, { type: eventName, payload: message.data })
  //           } catch(ex) {
  //             console.error(ex)
  //           }
  //         } else {
  //           console.error('got empty message');
  //         }
  //       } else {
  //         console.log('SKIPPING MESSAGE');
  //       }
  //     })
  //   })

  //   return () => {
  //     client.disconnect()
  //   }
  // }, [config, channels])

 // const connectionInitialized = (data) => {
  //   console.log("nats.connectionInitialized", data)
  //   setConnectionState("initialized")
  // }
  // // const connectionConnecting = (data) => {
  // //   console.log("nats.connectionConnecting", data)
  // //   setConnectionState("connecting")
  // // }
  // const connectionConnected = (data) => {
  //   console.log("nats.connectionConnected", data)
  //   setConnectionState("connected")
  // }
  // const connectionUnavailable = (data) => {
  //   console.log("nats.connectionUnavailable", data)
  //   setConnectionState("unavailable")
  // }
  // const connectionFailed = (data) => {
  //   console.log("nats.connectionFailed", data)
  //   setConnectionState("failed")
  // }
  // // const connectionDisconnected = (data) => {
  // //   console.log("nats.connectionDisconnected", data)
  // //   setConnectionState("disconnected")
  // // }
  // const connectionUnloading = (data) => {
  //   console.log("nats.connectionUnloading", data)
  //   setConnectionState("unloading")
  // }

}
  